import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25,
    },
  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserOrderLogList(query).then((res) => {
        commit('setUserList', res.data);
      });
    },
  },
};

appStore.registerModule('userOrderLog', store);
